import { makeObservable, action, runInAction, override, observable } from 'mobx';
import { CommonService } from './common';
import Home from './api.interface';
import { UC_TOGGLE_STATUS } from '@/stores/userInfo/userInfo.interface';
import { HomeModel, InvoiceToggleStatus, IndividualInvoiceInfoModel } from './home.model';
import { sendUserAction, UserActions } from '@/utils/v2/idap';

export class HomeService extends CommonService {
  constructor() {
    super();
    makeObservable(this);
  }

  @observable individualInvoiceInfo: IndividualInvoiceInfoModel = new IndividualInvoiceInfoModel();

  @override
  async getHomeInfo(): Promise<HomeModel> {
    const { code, result } = await this.post(Home.RefactorAPI.get_homepage);
    if (code === 0) {
      runInAction(() => {
        this.home = {
          ...this.home,
          ...result,
        };
      });
    }
    return result || this.home;
  }

  @override
  async updateUserConfig(params: {
    toggle_status?: UC_TOGGLE_STATUS;
    disburse_percentage?: number | string;
  }) {
    if (params?.toggle_status === UC_TOGGLE_STATUS.ENABLED) {
      sendUserAction(UserActions.Home.ClickEnable);
    }
    if (params?.toggle_status === UC_TOGGLE_STATUS.DISABLED) {
      sendUserAction(UserActions.Home.ClickDisable);
    }
    const result = await this.post(Home.RefactorAPI.update_user_config, {
      body: params,
      // manual: true,
    });
    return result;
  }

  @action
  async queryIndividualInvoiceInfo() {
    const { code, result } = await this.post(Home.RefactorAPI.query_individual_invoice_info);
    if (code === 0) {
      this.individualInvoiceInfo = {
        ...this.individualInvoiceInfo,
        ...result,
      };
    }
    return result || this.individualInvoiceInfo;
  }

  @action
  async updateIndividualInvoiceConfig(params: {
    individual_invoice_toggle_status?: InvoiceToggleStatus;
  }) {
    const result = await this.post(Home.RefactorAPI.update_individual_invoice_config, {
      body: params,
      // manual: true,
    });
    return result;
  }

  @override
  async getLatestDisbursedGroups() {
    return await this.post(Home.RefactorAPI.get_user_latest_disbursed_groups);
  }

  @override
  async updatePercentage(percentage: number) {
    this.home = {
      ...this.home,
      schedule_disburse_percentage: percentage,
    };
  }

  @action
  async saveHomeInfo(params: Partial<HomeModel>) {
    this.home = {
      ...this.home,
      ...params,
    };
  }

  @action
  async getLimitAdjustInfo() {
    const { code, result } = await this.post(Home.API.get_limit_adjust_info);
    if (code === 0) {
      const {
        limit_is_change,
        limit_change_time,
        from_id,
        from_limit,
        to_id,
        to_limit,
        temp_limit,
      } = result;

      runInAction(() => {
        this.home = {
          ...this.home,
          onboardingLimitAdjust: {
            limit_is_change,
            limit_change_time,
            from_id,
            from_limit,
            to_id,
            to_limit,
          },
          temporaryLimitAdjust: temp_limit?.[0] ?? {},
        };
      });
    }
  }

  @action
  async markLimitAdjust(params: { from_id?: number; to_id?: number; limit_type?: number }) {
    return await this.post(Home.API.commit_limit_change, {
      body: params,
    });
  }
}
